import {connect} from 'react-redux';
import {
  getNotificationMessagePage,
  markAsDeleted,
} from 'shared/notification-center/actions/notification-messages';
import {getUserId} from 'shared/notification-center/actions/user';
import MessageList from '..';
import {getNotificationsSelector} from 'shared/notification-center/reducers/selectors';

const mapStateToProps = (state) => {
  const {
    microscholarshipsLoading,
    student,
    notificationMessageIndexes,
    loading,
    loadMoreNotificationMessages,
  } = state;
  return {
    microscholarshipsLoading,
    student,
    loadMoreNotificationMessages,
    loading,
    notificationMessageIndexes: Array.from(notificationMessageIndexes),
    notificationMessages: getNotificationsSelector(state),
  };
};

export default connect(mapStateToProps, {
  getNotificationMessagePage,
  getStudentId: getUserId,
  markAsDeleted,
})(MessageList);
